import ReactDOM from "react-dom";
import "survey-core/defaultV2.min.css";
import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import { useCallback } from "react";
import moment from "moment";
import {
  tenantInteractionFinalSave,
  tenantInteractionResponseSubmit,
} from "@ovrture/react-redux";
import { applyThemeJson } from "./theme/applyThemeJson";
import { fetchText, interactionBarTemplate } from "./SurveyElements";
import { oldTenantList } from "./oldTenantInharidChecker";
import { getTenantOrgId } from "../migration/AdaLibMethods";
import {
  getInteractionResponse,
  getInteractionTabId,
  getResponseDataBackend,
  reloadInteractionOnSessionStart,
  setInteractionResponse,
  setInteractionSubmit,
} from "./store";
import { useEffect } from "react";
const surveyJSONResult = "surveyJSONResult";
let surveyModels = [];
let surveyModelObject = {};

export function SurveyOutputRender(props) {
  localStorage.removeItem("isFixedHeaderVariable");
  panelHeaderCheckListForOldTenant(true);
  const survey = new Model(props?.editorJSON);
  survey.license = process.env.REACT_APP_SURVEYJS_LICENSE;
  survey.cssVariables = applyThemeJson(fetchRebrandClass());
  setTimeout(() => {
    survey.cssVariables = applyThemeJson(fetchRebrandClass());
  }, 3000);

  let resultJsonOld = props?.resultData?.find(
    (f) => f.fkCpFolderViewId.toString() === props?.fkCpFolderViewId
  );
  if (resultJsonOld?.colResponseData) {
    let obj = JSON.parse(resultJsonOld?.colResponseData || "{}");
    let signatureKey = Object.keys(obj)[0];
    if (signatureKey?.includes("signaturepad")) {
      obj[signatureKey] = obj[signatureKey].url;
    }
    survey.data = obj;
  }
  surveyModels.push(survey);

  const handleResults = useCallback((sender) => {
    const results = JSON.stringify(sender.data);
    const slidesecclass = document
      ?.querySelector("[slidesecclass-id]")
      ?.getAttribute("slidesecclass-id");
    const cpFolderViewId = document
      ?.querySelector(
        `[id="${slidesecclass}"] .INTERACTION_PARENT:not(.IMPACT-SURVEY-PARENT)`
      )
      ?.getAttribute("folder_view_id");
    const activeTab = document?.querySelector(".report-update-data.active");
    props?.dispatch &&
      props.dispatch(
        tenantInteractionFinalSave({
          fkCpFolderViewId: cpFolderViewId,
          // fkSiteId: props.data?.pkSiteId,
          // fkReportId: props.data?.pkReportId,
          fkReportUpdatesId: activeTab?.getAttribute(
            "data-pk_report_update_id"
          ),
          colReportUpdatesName: activeTab?.querySelector("p")?.textContent,
          colResponseData: results,
          ...(props?.data?.pkSiteId ? { fkSiteId: props?.data?.pkSiteId } : {}),
          ...(props?.data?.pkReportId
            ? { fkReportId: props?.data?.pkReportId }
            : {}),
          ...(props?.data?.surveyRecipientResponseDTO?.tblSurvey?.pkSurveyId
            ? {
                fkSurveyId:
                  props?.data?.surveyRecipientResponseDTO?.tblSurvey
                    ?.pkSurveyId,
              }
            : {}),
          ...(props?.data?.pkRecipientId
            ? { fkRecipientId: props?.data?.pkRecipientId }
            : {}),
        })
      );
    sender.clear();
  }, []);

  survey.onComplete.add((sender, options) => {
    surveyModelObject = sender.data;
    sender.clear();
    sender.data = surveyModelObject;
  });

  survey.onValueChanged.add((sender, options) => {
    const slidesecclass = options?.question
      ?.getWrapperElement()
      ?.closest(".slideSecClass")
      ?.getAttribute("id");

    const INTERACTION_PARENT = document?.querySelector(
      `[id="${slidesecclass}"] .INTERACTION_PARENT:not(.IMPACT-SURVEY-PARENT)`
    );
    autoSaveInteractionPanelResults(
      sender.data,
      INTERACTION_PARENT,
      props?.dispatch,
      props?.data,
      props?.resultData,
      props?.sessionId
    );
  });
  return <Survey model={survey} />;
}

const autoSaveInteractionPanelResults = (
  data,
  INTERACTION_PARENT,
  propsdispatch,
  propsdata,
  resultData,
  sessionId,
  isSubmit
) => {
  let results = JSON.stringify(data);
  const cpFolderViewId = INTERACTION_PARENT?.getAttribute("folder_view_id");
  sessionStorage.setItem(
    process.env.REACT_APP_DASHBOARD_SESSION_GENERIC_MSG_KEY,
    "SKIP_LOADER_SKIP_GENERIC_MSG"
  );
  const activeTab = document?.querySelector(".report-update-data.active");
  propsdispatch &&
    propsdispatch(
      tenantInteractionFinalSave({
        fkCpFolderViewId: cpFolderViewId,
        // fkSiteId: propsdata?.pkSiteId,
        // fkReportId: propsdata?.pkReportId,
        fkReportUpdatesId: activeTab?.getAttribute("data-pk_report_update_id"),
        colReportUpdatesName: activeTab?.querySelector("p")?.textContent,
        colResponseData: results,
        ...(propsdata?.pkSiteId ? { fkSiteId: propsdata?.pkSiteId } : {}),
        ...(propsdata?.pkReportId ? { fkReportId: propsdata?.pkReportId } : {}),
        ...(propsdata?.surveyRecipientResponseDTO?.tblSurvey?.pkSurveyId
          ? {
              fkSurveyId:
                propsdata?.surveyRecipientResponseDTO?.tblSurvey?.pkSurveyId,
            }
          : {}),
        ...(propsdata?.pkRecipientId
          ? { fkRecipientId: propsdata?.pkRecipientId }
          : {}),
      })
    );
  let obj = getResponseDataBackend(sessionId, resultData, propsdata);
  let colIsIpResponseSubmitted = false;
  let colIsImpactSurveyResponseSubmitted = document?.querySelector(
    `.INTERACTION_PARENT.IMPACT-SURVEY-PARENT`
  )
    ? document?.querySelector(".impactSurveyStatus")?.textContent?.trim() ===
      "Completed"
      ? true
      : false
    : true;
  if (propsdata?.surveyRecipientResponseDTO) {
    if (colIsIpResponseSubmitted && colIsImpactSurveyResponseSubmitted) {
      colIsIpResponseSubmitted = true;
    } else if (
      colIsIpResponseSubmitted &&
      colIsImpactSurveyResponseSubmitted === false
    ) {
      colIsIpResponseSubmitted = false;
    }
  }
  let lastUpdatedDate = obj?.lastUpdatedDate;
  !isSubmit &&
    setInteractionResponse(
      cpFolderViewId,
      results,
      moment,
      lastUpdatedDate,
      colIsIpResponseSubmitted,
      propsdata
    );
};

const removeAllObjExcept = (obj, keysToKeep) => {
  if (keysToKeep === "comment") {
    keysToKeep = "textlong";
  } else if (keysToKeep === "dropdownWithoutText") {
    keysToKeep = "dropdown";
  }
  // Convert keysToKeep to an array if it's a string
  const keys = [keysToKeep, keysToKeep + "-Comment"];

  // Iterate over the object keys
  Object.keys(obj).forEach((key) => {
    // If the key is not in the keysToKeep array, delete it
    if (!keys.includes(key)) {
      delete obj[key];
    }
  });

  return obj; // Return the modified object
};

const fetchRebrandClass = () => {
  let rebrand = null;
  let allClassList = document?.body?.classList;
  allClassList?.forEach((selector) => {
    const tenantId = Number(getTenantOrgId());
    const tenant = oldTenantList?.find((item) => item.id === tenantId);
    if (tenant) {
      let bodys = tenant?.body?.split("|");
      let classes = tenant?.class?.split("|");
      for (let index = 0; index < bodys.length; index++) {
        const element = bodys[index];
        if (element === selector) {
          rebrand = bodys[index];
          break;
        }
      }
    } else {
      if (
        selector?.toLowerCase()?.includes("rebrand") ||
        selector?.toLowerCase()?.includes("body")
      ) {
        rebrand = selector;
      }
    }
  });
  // if (rebrand) {
  const INTERACTION_PARENT = document?.querySelectorAll(
    ".INTERACTION_PARENT:not(.IMPACT-SURVEY-PARENT)"
  );
  INTERACTION_PARENT?.forEach((rootHtmlElement) => {
    rebrand && rootHtmlElement.classList.add(rebrand.replace("_BODY", ""));
    replaceSvgElement(rootHtmlElement, rebrand || "");
  });
  // }
  return rebrand;
};

export const panelHeaderCheckListForOldTenant = (isEditor) => {
  setTimeout(() => {
    const tenantId = Number(getTenantOrgId());
    const tenant = oldTenantList?.find((item) => item.id === tenantId);
    const rebrand = fetchRebrandClass();
    if (tenant) {
      switch (tenant.place) {
        case "INTERACTION_PARENT_NEW":
          document
            ?.querySelectorAll('[cpid][id="INTERACTION_PARENT_NEW"]')
            ?.forEach((ele) => {
              let classes = tenant?.class?.split("|");
              let bodys = tenant?.body?.split("|");
              for (let index = 0; index < classes.length; index++) {
                if (isEditor) {
                  //if (document.querySelector('.' + item))
                  if (document?.body?.classList?.contains(bodys[index])) {
                    ele.classList.add(classes[index]);
                    // ele.classList.add(bodys[index]);
                    break;
                  } else {
                    classes[0] && ele.classList.add(classes[0]);
                    // ele.classList.add(bodys[0]);
                    break;
                  }
                } else {
                  classes[0] && ele.classList.add(classes[0]);
                  // ele.classList.add(bodys[0]);
                  break;
                }
              }
            });
          break;
      }
    }
  }, 2000);
};

const replaceSvgElement = (rootHtmlElement, rebrand) => {
  const width = window.innerWidth;
  if (width >= 320 && width <= 991) {
    let customSvg = getComputedStyle(document.documentElement).getPropertyValue(
      "--sjs-mobile-accordion-svg-ctm" + rebrand
    );
    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(customSvg, "text/html");
    const newSvgElement =
      svgDoc.querySelector("span") || svgDoc.querySelector("svg");

    const oldSvgElement = rootHtmlElement.querySelectorAll(
      ".mobile-view-only svg"
    );
    if (oldSvgElement?.length === 1 && newSvgElement) {
      oldSvgElement[0].parentNode.replaceChild(newSvgElement, oldSvgElement[0]);
    }
  }
};

export const insertSurveyOnOutput = (
  setLoading,
  dispatch,
  data,
  resultData,
  sessionId
) => {
  surveyObjectClear();
  const INTERACTION_PARENT = document?.querySelectorAll(
    ".INTERACTION_PARENT:not(.IMPACT-SURVEY-PARENT)"
  );
  INTERACTION_PARENT?.forEach((rootHtmlElement) => {
    const attrJson = JSON.parse(
      rootHtmlElement.querySelector(".interactionHiddenField").value
    );
    if (rootHtmlElement) {
      ReactDOM.render(
        <SurveyOutputRender
          editorJSON={attrJson}
          dispatch={dispatch}
          data={data}
          resultData={resultData}
          sessionId={sessionId}
          fkCpFolderViewId={rootHtmlElement?.getAttribute("folder_view_id")}
        />,
        rootHtmlElement.querySelector(".survey-editor")
      );
    }
  });
  const completeButton_ = document.querySelector(".interaction-bar");
  completeButton_ && completeButton_.remove();
  const INTERACTION_PARENT_ = document?.querySelectorAll(".INTERACTION_PARENT");
  if (INTERACTION_PARENT?.length === 0 && INTERACTION_PARENT_?.length > 0) {
    setTimeout(() => {
      applyThemeJson(fetchRebrandClass());
    }, 3000);
  }

  let numberOfQuestionsMandatory = data?.anyMandatoryFieldIsPresent ? 1 : 0;
  document.querySelectorAll(".interactionHiddenField").forEach((element) => {
    const jsonObj = JSON.parse(element.value);
    if (jsonObj?.pages?.length > 0 && jsonObj?.pages[0]?.elements?.length > 0) {
      const firstElement = jsonObj?.pages[0]?.elements[0];
      if (firstElement?.isRequired) {
        numberOfQuestionsMandatory += 1;
      }
    }
  });
  INTERACTION_PARENT_?.length > 0 &&
    addInteractiveFeature(
      setLoading,
      dispatch,
      data,
      INTERACTION_PARENT_?.length,
      INTERACTION_PARENT_,
      resultData,
      sessionId,
      numberOfQuestionsMandatory
    );
};

const surveyObjectClear = () => {
  surveyModels.forEach((survey) => {
    survey.clear();
  });
  surveyModels = [];
  surveyModelObject = {};
};

export const getSurveyModel = () => {
  return surveyModels;
};

// export const fetchAnsweredMandatory = (interactionResponses, data) => {
//   let answeredMandatory =
//     data?.anyMandatoryFieldIsPresent &&
//     document?.querySelector(".impactSurveyStatus")?.textContent?.trim() ===
//       "Completed"
//       ? 1
//       : 0;
//   Object?.keys(interactionResponses)?.forEach((key) => {
//     const jsonObj = JSON.parse(
//       document.querySelector(
//         `[folder_view_id='${key}'] .interactionHiddenField`
//       ).value
//     );
//     if (jsonObj?.pages?.length > 0 && jsonObj?.pages[0]?.elements?.length > 0) {
//       const firstElement = jsonObj?.pages[0]?.elements[0];
//       if (firstElement?.isRequired) {
//         answeredMandatory += 1;
//       }
//     }
//   });
//   return answeredMandatory;
// };
export const fetchAnsweredMandatory = (interactionResponses, data) => {
  let answeredMandatory =
    data?.anyMandatoryFieldIsPresent &&
    document?.querySelector(".impactSurveyStatus")?.textContent?.trim() ===
      "Completed"
      ? 1
      : 0;

  if (!interactionResponses || typeof interactionResponses !== "object") {
    return answeredMandatory;
  }

  Object.keys(interactionResponses).forEach((key) => {
    const hiddenField = document.querySelector(
      `[folder_view_id='${key}'] .interactionHiddenField`
    );
    if (!hiddenField) return;

    let jsonObj;
    try {
      jsonObj = JSON.parse(hiddenField.value);
    } catch {
      return;
    }

    if (jsonObj?.pages?.length > 0 && jsonObj?.pages[0]?.elements?.length > 0) {
      const firstElement = jsonObj.pages[0].elements[0];
      if (firstElement?.isRequired) {
        answeredMandatory += 1;
      }
    }
  });

  return answeredMandatory;
};

const addInteractiveFeature = (
  setLoading,
  dispatch,
  data,
  numberOfQuetions,
  INTERACTION_PARENT,
  resultData,
  sessionId,
  numberOfQuetionsMandatory
) => {
  let interactionResponses = getInteractionResponse();
  let tabId = getInteractionTabId();
  if (interactionResponses[tabId] === undefined) {
    interactionResponses[tabId] = {};
  }
  let answered = Object.keys(interactionResponses[tabId])?.length;
  let answeredMandatory = fetchAnsweredMandatory(
    interactionResponses[tabId],
    data
  );
  let changes =
    answered > 0
      ? "Autosave: " + moment(new Date()).format("MMM D, YYYY, h:mm a")
      : "No changes made";
  let section = document.getElementById("greetingsPanel");
  if (window?.location?.pathname?.includes("surveys")) {
    section = document.getElementsByTagName("header");
  }
  if (section) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = interactionBarTemplate(
      answered,
      numberOfQuetions,
      changes,
      numberOfQuetionsMandatory,
      answeredMandatory,
      data?.surveyRecipientResponseDTO?.tblSurvey?.colSurveyDeadlineDate
        ? moment(
            new Date(
              data?.surveyRecipientResponseDTO?.tblSurvey?.colSurveyDeadlineDate
            )
          ).format("MMM D YYYY")
        : ""
    );
    if (window?.location?.pathname?.includes("surveys")) {
      section[0].parentNode.insertBefore(tempDiv.firstElementChild, section[0]);
    } else {
      section.parentNode.insertBefore(
        tempDiv.firstElementChild,
        section.nextSibling
      );
    }

    setTimeout(() => {
      reloadInteractionOnSessionStart(data, resultData, moment, sessionId);
    }, 2000);
    const completeButton = document.querySelector(
      "#INTERACTION_BANNER .interaction-complete-btn"
    );
    if (completeButton) {
      completeButton.addEventListener("click", () => {
        const INTERACTION_PARENT_ALL = document?.querySelectorAll(
          `.INTERACTION_PARENT:not(.IMPACT-SURVEY-PARENT)`
        );
        let isValidated = true;
        for (let i = 0; i < INTERACTION_PARENT_ALL?.length; i++) {
          const survey = surveyModels[i];
          const isValid = survey.validate();
          if (!isValid) {
            isValidated = false;
            let errorElement = INTERACTION_PARENT_ALL[i];
            // errorElement
            //   .querySelector(".sd-btn--action.sd-navigation__complete-btn")
            //   .click();
            errorElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            errorElement.focus();
            break;
          }
        }

        if (isValidated) {
          setLoading(true);
          INTERACTION_PARENT_ALL?.forEach((element) => {
            const dataKey = JSON.parse(
              element.querySelector(".interactionHiddenField").value
            ).pages[0].elements[0].name;
            const surveyModelObj = surveyModels.find((survey) =>
              survey.data?.hasOwnProperty(dataKey)
            );
            autoSaveInteractionPanelResults(
              surveyModelObj?.data,
              element,
              dispatch,
              data,
              resultData,
              sessionId,
              true
            );
          });
          setTimeout(() => {
            sessionStorage.removeItem(
              process.env.REACT_APP_DASHBOARD_SESSION_GENERIC_MSG_KEY
            );
            dispatch &&
              dispatch(
                tenantInteractionResponseSubmit({
                  // fkSiteId: data?.pkSiteId,
                  // fkReportId: data?.pkReportId,
                  fkReportUpdatesId: document
                    ?.querySelector(".report-update-data.active")
                    ?.getAttribute("data-pk_report_update_id"),
                  ...(data?.pkSiteId ? { fkSiteId: data?.pkSiteId } : {}),
                  ...(data?.pkReportId ? { fkReportId: data?.pkReportId } : {}),
                  ...(data?.surveyRecipientResponseDTO?.tblSurvey?.pkSurveyId
                    ? {
                        fkSurveyId:
                          data?.surveyRecipientResponseDTO?.tblSurvey
                            ?.pkSurveyId,
                      }
                    : {}),
                  ...(data?.pkRecipientId
                    ? { fkRecipientId: data?.pkRecipientId }
                    : {}),
                })
              );
            document
              .querySelector(".interaction-bar .interaction-complete-btn")
              .classList.add("disabled");
          }, 2000);
          // setInteractionSubmit(true);
        }
      });
    }
  }
};

export const clearSurveyJSON = () => {
  localStorage.removeItem(surveyJSONResult);
};

export const insertSurveyOnPreview = () => {
  document
    .querySelectorAll(
      '[id="previewOnly"] .INTERACTION_PARENT:not(.IMPACT-SURVEY-PARENT)'
    )
    .forEach((rootHtmlElement) => {
      const attrJson = JSON.parse(
        rootHtmlElement.querySelector(".interactionHiddenField").value
      );
      if (rootHtmlElement) {
        ReactDOM.render(
          <SurveyOutputRender editorJSON={attrJson} />,
          rootHtmlElement.querySelector(".survey-editor")
        );
      }
    });
};

export const setSurveyJSON = (json, dispatch) => {
  let obj = JSON.parse(localStorage.getItem(surveyJSONResult)) || [];
  if (obj.find((f) => f.fkCpFolderViewId === json.fkCpFolderViewId)) {
    let index = obj.findIndex(
      (f) => f.fkCpFolderViewId === json.fkCpFolderViewId
    );
    if (obj[index].colResponseData !== json?.colResponseData) {
      dispatch && dispatch(tenantInteractionFinalSave(json));
      obj[index].colResponseData = json?.colResponseData;
    }
  } else {
    obj.push(json);
    json?.colResponseData &&
      dispatch &&
      dispatch(tenantInteractionFinalSave(json));
  }
  localStorage.setItem(surveyJSONResult, JSON.stringify(obj));
};

export const getSurveyJSON = () => {
  return JSON.parse(localStorage.getItem(surveyJSONResult));
};
